import Viewer from './MultipleAnswerFieldsViewer';
import MultipleAnswerFieldsEditor from './MultipleAnswerFieldsEditor';

export const MultipleAnswerFieldsViewer = Viewer;
export default MultipleAnswerFieldsEditor;
